import { ExtendedApiError } from "../../../components-shared/api/base/extended-api-error.js";
import { IExtendedApiResponse } from "../../../components-shared/api/base/i-extended-api-response.js";

export class SupplierOrderInfo extends HTMLElement {
    productId: number;

    markup = (lines:string[]) => lines && lines.length ? 
        `<ul style="list-style:none;padding:0;margin:0;">${lines.map(l => `<li>${l}</li>`).join("")}</ul>` : null;

    constructor(productId: number) {
        super();
        this.productId = productId;
        this.attachShadow({mode: "open"});
    }

    getProductIdAttr(): number {
        const productIdAttr = this.getAttribute("product-id");
        if (productIdAttr && productIdAttr.length) {
            return parseInt(productIdAttr);
        }

        return null;
    }

    async update(productId: number) {
        this.productId = productId;
        await this.load();
    }

    async attributeChangedCallback() {
        const newProductId = this.getProductIdAttr();

        if (newProductId) {
            await this.update(newProductId);
        }
    }

    async connectedCallback() {
        if (!this.productId) {
            this.productId = this.getProductIdAttr();
        }

        await this.load();
    }

    async load(): Promise<void> {
        if (this.productId) {
            const response = await fetch(`/api/estore/stock/${this.productId}/supplier-order-info`);

            const dataResponse = await response.json() as IExtendedApiResponse<string[]>;

            if (!dataResponse || dataResponse.hasError) {
                throw new ExtendedApiError(dataResponse);
            }

            this.render(dataResponse.result);
        }
    }

    render(lines: string[]) {
        this.shadowRoot.innerHTML = this.markup(lines);
    }
}

customElements.define("supplier-order-info", SupplierOrderInfo);